import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative bg-white border-t border-gray-200" id="footer">
      {/* Banderole animée avec un nom de classe unique */}
      <div className="footer-banner bg-black text-white py-4 overflow-hidden">
        <div className="footer-scroll-animation whitespace-nowrap">
          <span className="text-sm font-medium tracking-wider mx-8">
            SAFAA SHIEY • MOROCCAN ARTIST • SOUL & R&B • MODEL • ACTRESS • TV REPORTER • @SAFAH.SHISEY
          </span>
          <span className="text-sm font-medium tracking-wider mx-8">
            SAFAA SHIEY • MOROCCAN ARTIST • SOUL & R&B • MODEL • ACTRESS • TV REPORTER • @SAFAH.SHISEY
          </span>
        </div>
      </div>

      {/* Contenu principal du footer */}
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-12 lg:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-12">
          
          {/* Colonne Brand */}
          <div className="lg:col-span-1">
            <div className="flex flex-col space-y-4">
              <h3 className="text-2xl font-light text-gray-900 tracking-tight">
                @safah.shisey
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed max-w-xs">
                Moroccan soul and R&B singer, model, actress and television reporter.
              </p>
              <div className="flex space-x-4 pt-2">
                <a 
                  href="https://www.instagram.com/safah.shisey/" 
                  className="text-gray-400 hover:text-yellow-500 transition-colors duration-300"
                  aria-label="Instagram"
                >
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                  </svg>
                </a>
              </div>
            </div>
          </div>

          {/* Colonne Navigation */}
          <div className="lg:col-span-1">
            <h4 className="text-sm font-semibold text-gray-900 tracking-wider uppercase mb-6">
              Navigation
            </h4>
            <nav className="flex flex-col space-y-4">
              <a 
                href="#about" 
                className="text-gray-600 hover:text-yellow-500 transition-colors duration-300 text-sm"
              >
                About
              </a>
              <a 
                href="#experience" 
                className="text-gray-600 hover:text-yellow-500 transition-colors duration-300 text-sm"
              >
                Experience
              </a>
              <a 
                href="#highlights" 
                className="text-gray-600 hover:text-yellow-500 transition-colors duration-300 text-sm"
              >
                Highlights
              </a>
              <a 
                href="#footer" 
                className="text-gray-600 hover:text-yellow-500 transition-colors duration-300 text-sm"
              >
                Contact
              </a>
            </nav>
          </div>

          {/* Colonne Contact */}
          <div className="lg:col-span-1">
            <h4 className="text-sm font-semibold text-gray-900 tracking-wider uppercase mb-6">
              Contact
            </h4>
            <div className="flex flex-col space-y-4 text-sm text-gray-600">
              <a 
                href="mailto:info@alfinproducciones.com"
                className="hover:text-yellow-500 transition-colors duration-300"
              >
                info@alfinproducciones.com
              </a>
              <a 
                href="tel:+34917584672"
                className="hover:text-yellow-500 transition-colors duration-300"
              >
                (+34) 91 758 46 72
              </a>
              <p className="leading-relaxed">
                Available worldwide
              </p>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-gray-200 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-gray-500">
              © {currentYear} Safaa Shiey. All rights reserved.
            </p>
            <div className="flex space-x-6 text-sm text-gray-500">
              <button 
                type="button"
                className="hover:text-yellow-500 transition-colors duration-300 bg-transparent border-none cursor-pointer"
                onClick={() => console.log('Privacy Policy clicked')}
              >
                Privacy Policy
              </button>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        /* Classes uniques pour éviter les conflits avec le carrousel */
        .footer-scroll-animation {
          animation: footer-scroll 30s linear infinite;
          display: inline-block;
        }

        .footer-banner:hover .footer-scroll-animation {
          animation-play-state: paused;
        }

        @keyframes footer-scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }

        /* S'assurer que les styles du footer n'affectent pas le carrousel */
        .footer-banner {
          isolation: isolate;
        }

        .footer-banner * {
          box-sizing: border-box;
        }
      `}</style>
    </footer>
  );
};

export default Footer;